export const SERVICE_MAIL = 'service@linetv.tw';
export const SALES_MAIL = 'sales@choco.media';

export const HELP_HOST = 'https://help.linetv.tw';

export const MAIL_BODY_DEFAULT = `
%0D%0A%0D%0A請提供下列資訊：%0D%0A%0D%0A
1) 手機廠牌和型號 (iOS / Android)：%0D%0A%0D%0A
2) LINE TV APP 版本 (iOS > LINE TV 個人頁 > 軟體版本；Android > LINE TV 個人頁 > 軟體版本)：%0D%0A%0D%0A
3) 請說明您所遇到的問題戲劇名稱跟集數，或可提供截圖或錄影畫面。若要查詢點數，請提供您參加的活動名稱。%0D%0A%0D%0A
※ 建議您先瀏覽問題中心 (${HELP_HOST})，可以更快速解答您的疑問%0D%0A%0D%0A
`;
export const MAIL_BODY_CANCEL_SUBSCRIPTION_ERROR = `
%0D%0A%0D%0A請提供下列資訊：%0D%0A%0D%0A
1）取消訂閱失敗的畫面截圖：%0D%0A%0D%0A
2）遇到的問題：%0D%0A%0D%0A
`;
export const MAIL_BODY_CANCEL_SUBSCRIPTION = `
很遺憾您取消 LINE TV 的會員服務，請告訴我們您取消訂閱的原因以利我們可以改善和進步：%0D%0A
1) 沒時間觀看。%0D%0A
2) 沒有想看的劇。%0D%0A
3) 只想訂一次。%0D%0A
4) 產品功能問題：%0D%0A
5) 已有訂閱別家會員服務：%0D%0A
6) 其他：%0D%0A
`;
export const SERVICE_HOURS = 'LINE TV 客服團隊服務時間：週一至週五 10:00-18:00，不含國定假日​​。我們會儘速回覆您，謝謝！';

export const FACEBOOK_FAN_URL = 'https://www.facebook.com/LINETV.taiwan/';
export const INSTAGRAM_FAN_URL = 'https://www.instagram.com/linetv.tw/';
export const YOUTUBE_FAN_URL = 'https://www.youtube.com/channel/UCouTB9QM76no5cUdqmFZCOQ';
export const APPLE_STORE_URL = 'https://itunes.apple.com/tw/app/choco-tv-%E8%BF%BD%E5%8A%87%E7%98%8B/id1005557642?l=zh&mt=8';
export const GOOGLE_STORE_URL = 'https://play.google.com/store/apps/details?id=com.chocolabs.app.chocotv&hl=zh_TW';
export const JOBBANK_URL = 'https://www.104.com.tw/jobbank/custjob/index.php?r=cust&j=394b436c35373f6831333b64393f371a72a2a2a6c4237592674j57';

export const SERVICE_TERMS_URL = 'https://static.linetv.tw/terms/service/service-terms.html';
export const PRIVACY_TERMS_URL = 'https://static.linetv.tw/terms/privacy/privacy-terms.html';

export const PAYMENT_VIP_TERMS_URL = 'https://static.linetv.tw/terms/payment/vip-terms.html';
export const PACKAGE_SUBSCRIBE_TERMS_URL = 'https://static.linetv.tw/terms/payment/content-subscription-terms.html';
export const PACKAGE_RENT_TERMS_URL = 'https://static.linetv.tw/terms/payment/tvod-terms.html';